<template>
  <div>
    <div class="testimonial-carousel">
      <VueAgile
        :options="options"
        ref="carousel"
      >
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          :class="`slide--${index}`"
          class="slide"
        >
          <TestimonialCard
            :person_image="testimonial.person_image"
            :person_name="testimonial.person_name"
            :person_info="testimonial.person_info"
            :text="testimonial.text"
          />
        </div>
        <template slot="prevButton"><i class="fa fa-angle-left"></i></template>
        <template slot="nextButton"><i class="fa fa-angle-right"></i></template>
      </VueAgile>
    </div>
  </div>
</template>

<script>

import TestimonialCard from '@/components/common/Testimonial/TestimonialCard'
import { VueAgile } from 'vue-agile'

export default {
  name: 'TestimonialCarousel',
  props: ['testimonials'],
  components: {
    TestimonialCard,
    VueAgile
  },
  data () {
    return {
      options: {
        dots: false,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">

.testimonial-carousel {
  ::v-deep {
    .testimonial-card-wrapper {
      padding: 10px;
    }

    .agile__slides {
    }

    .agile__nav-button {
      position: absolute;
      top: calc(50% - 15px);
      background: transparent;
      padding: 0;
      border: none;

      @include tablet {
        top: calc(50% - 30px);
      }

      i {
        color: $color2;
        font-size: 30px;

        @include tablet {
          font-size: 50px;
        }
      }
    }

    .agile__nav-button--prev {
      left: -10px;

      @include tablet {
        left: -25px;
      }
    }

    .agile__nav-button--next {
      right: -10px;

      @include tablet {
        right: -25px;
      }
    }
  }

}
</style>
